/* eslint-disable @typescript-eslint/no-unused-vars */
// src/page-section/landing/FAQSection.tsx
import { cn } from "@/lib/utils";
import HeroSectionChildren from "@/wireframes/page-sections/hero/HeroSectionChildren";
import BlurIn from "@/wireframes/text-animations/blur-in";
import faqImage from "@/assets/vani/logos/vani-06.png";
import AccordionComponent from "@/components/accordion/accordion-component";

const FAQSection: React.FC = () => {
  const accordionData = [
    {
      title: "What does Vani do?",
      content:
        "A Vani translator tool that converts text or speech from one language to another, either through machine-based tools or human linguists.",
    },
    {
      title:
        "How accurate are machine Vani translators compared to human translators?",
      content:
        "Machine Vani translators are improving but may miss nuances; human translators are generally more accurate for context and cultural subtleties.",
    },
    {
      title: "Can Vani translators handle real-time speech translation?",
      content:
        "Yes, many tools like Google Translate can translate speech in real-time, though accuracy can vary based on factors like accents and background noise.",
    },
    {
      title: "Are there limitations to what Vani translators can translate?",
      content:
        "Yes, they may struggle with slang, idioms, cultural references, and specialized terms. Less common languages may also have limited support.",
    },
  ];
  const Faq = () => {
    return (
      <div className="flex flex-col justify-center items-center">
        <div className="container mx-auto px-4 py-4 mb-10">
          <header className="text-center md:text-start mb-8 px-4 sm:my-10 text-wrap">
            <BlurIn
              word={`FAQ's`}
              className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-normal font-bold text-accent"
            />
          </header>
          <div className="flex flex-col lg:flex-row">
            <div className="flex-1 flex justify-center items-center px-4 mt-10 lg:mt-0">
              <img
                src={faqImage}
                alt="vani-faq"
                className={cn("w-96 h-auto")}
              />
            </div>
            <div className="flex-2 w-full justify-center items-center text-sm md:text-lg text-start text-balance max-w-3xl pb-3 ">
              {accordionData.map((faq) => (
                <div className="mb-1">
                  <AccordionComponent
                    question={faq.title}
                    answer={faq.content}
                    classNameAccordion="text-black w-1/1 rounded-b-lg shadow-lg"
                    classNameAccordionTrigger="text-start w-full border border-black bg-transparent rounded-b-lg shadow-lg"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return <HeroSectionChildren id="faq" children={<Faq />} />;
};

export default FAQSection;
